import { HelmetDexteel } from "@dexteel/mesf-core";
import { ProductsWithNoRecipeReport } from "./components/ProductsWithNoRecipeReport";

export const ProductsWithNoRecipePage = () => {
	return (
		<>
			<HelmetDexteel title="Products with no Recipe" />
			<ProductsWithNoRecipeReport />
		</>
	);
};
